<template>
	<div >
		<img src="../../../../public/pic/product/srt/A.png" style="width: 100%;"/>
		<br /><br /><br /><br />
		<div style="width: 90%;" class="center_sun">
			<p class="indent">
				{{ $t('lang.Uniquely_designed')}}
			</p>
			<video controls ref="video" style="width: 90%;">
				<source src="../../../../public/pic/product/srt/mp4.mp4" type="video/mp4" >
			</video>
			<hr />
			<div id="box1">
				<div id="box2">
					<img src="../../../../public/pic/product/srt/Aa3.png"/>
				</div>
				<div id="wenzi" >
					<p style="font-size: 15px;">{{ $t('lang.Omnidirectional')}}</p>
					<p class="indent" style="text-align: justify;font-size: 10px;">
						{{ $t('lang.Equipped')}}
					</p>
				</div>
			</div>
			<hr />
			<img src="../../../../public/pic/product/srt/Ab3.png" style="width: 100%;"/>
			<img v-show="this.$i18n.locale == 'zh'" src="../../../../public/pic/product/srt/A1.png" style="width: 100%;height: 100%;"/>
			<img v-show="this.$i18n.locale == 'en'" src="../../../../public/pic/product/srt/AA1.png" style="width: 100%;height: 100%;"/>

			<hr />
			<img src="../../../../public/pic/product/srt/A3.png" style="width: 100%;"/>
			<hr />
			<h2 >{{ $t('lang.uvc_p2')}}</h2>
			<br /><br />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../../public/pic/product/srt/srtzh.png" />
			<img v-show="this.$i18n.locale == 'en'" src="../../../../public/pic/product/srt/srten.png" />
			
			<br /><br /><br /><br />
		</div>
	</div>
</template>

<script>
export default {
	head(){
		return {
			title : '喷雾消毒机器人_深圳全智能机器人科技有限公司 Spray disinfection robot_Shenzhen all intelligent robot technology Co., Ltd',
			keywords : '喷雾消毒机器人,智能消毒设备,消毒机器人厂家,医用消毒机器人,空气消毒机,全智能消毒机器人,智能喷雾消毒机器人 Spray disinfection robot, intelligent disinfection equipment, disinfection robot manufacturer, medical disinfection robot, air disinfector, intelligent disinfection robot, intelligent spray disinfection robot',
			description : '深圳全智能机器人科技有限公司研发生产的喷雾消毒机器人是全球首款多种智能消毒模式的智能设备，极致的消毒设计，多种模式可智能语音控制，让人机交互体验更进一步，消毒从此安全有效。 The spray disinfection robot developed by Shenzhen all intelligent robot technology Co., Ltd. is the world\'s first intelligent equipment with multiple intelligent disinfection modes. With extreme disinfection design, multiple disinfection modes to choose, intelligent voice control, human-computer coexistence, which make the human-computer interaction experience further, so that disinfection is safer and more effective.',
		};
	},
}
</script>

<style scoped>
	
	#box1{
	
	position:relative;
	
	width:100%;
	
	height:500px;
	
	margin:0 auto;
	
	}
	
	#box2{
	
	position:relative;
	
	width:100%;
	
	height:100%;
	
	}
	
	img{
	
	position:relative;
	
	clear:both;
	
	width:100%;
	
	height:100%;
	
	}
	
	#wenzi{
	
	position:relative;
	
	clear:both;
	
	width:150px;
	
	top:-47%;
	left: 50%;
	
	text-align:center;
	
	color:white;
	
	font-size:30px;
	
	}
	p{
		font-size: 15px;
		text-align: justify;/*外部引人入的不生效*/
	}
</style>
